import axios from "axios";
import React, { useEffect, useState } from "react";
import styles from "./styles.css";
import Select from "react-select";
// reactstrap components
import {
  Input,
} from "reactstrap";

import { URL_API } from "variable";
import { EditorState } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "react-quill/dist/quill.snow.css";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { IMAGE_URL } from "variable";

toast.configure();

function SliderEdit() {
 
  const [editorState, setEditorState] = useState(() =>
    EditorState.createEmpty()
  );
  const id = useParams();
  const history = useHistory();
  const [title, setTitle] = useState();
  const [image, setImage] = useState();


  useEffect(() => {
    getSlider();
    let token = localStorage.getItem("token");
  }, []);

  const onTitleChange = (e) => {
    setTitle([e.target.value]);
  };


  const onImageChange = (event) => {
    if (!event.target.files[0]) {
      return false;
    } else {
      let files = event.target.files || event.dataTransfer.files;
      if (!files.length) return;
      setImage(files[0]);
    }
  };

  const getSlider = () => {
    axios.get(URL_API + `auth/admin/sliders/${id.id}/edit`).then((response) => {
      console.log('enquiry',response);
      if (response.data.status === 200) {
        setTitle(response.data.slider.title);
        setImage(response.data.slider.image);
      }
    });
  };

  
  const onSubmit = (event) => {
    event.preventDefault();

    let formData = new FormData();
    formData.append("title", title);
    formData.append("image", image);

    axios
      .post(URL_API + `auth/admin/sliders/update-slider/${id.id}`, formData)
      .then((response) => {
        if (response.status == 200) {
          history.push("/admin/sliders");
          toast.success("Slider Updated Successfully", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2000,
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <div className="content">
        <form onSubmit={(e) => onSubmit(e)}>
          <div className={`container-fluid`}>
            <div className={styles.HeroiImgBlogForm}>
              <div className={styles.paddingTopBottomBlogForm}>
                <h3 className={styles.HeroiImgTextBlogForm}>Update Slider</h3>
              </div>
            </div>
            <br />
            <div className="container">
              <div className={`form ${styles.blogPostForm}`}>
                <div className="form-group">
                  <label htmlFor="post-title" className={styles.labelPostForm}>
                    Title
                  </label>
                  <Input
                    name="title"
                    type="text"
                    //   class={`form-control ${styles.blogPostFormInput}`}
                    id="post-title"
                    required="required"
                    value={title}
                    onChange={(e) => onTitleChange(e)}
                  />

                </div>
                <br />
                {/* <div className="form-group">
                  <label
                    htmlFor="post-description"
                    className={styles.labelPostForm}
                  >
                    Ad Description{" "}
                    <span className={styles.blogFormDesciptionSpan}>
                      Enter long description for your project
                    </span>
                  </label>
                  <Input
                    component="textarea"
                    name="article_text"
                    //   class={`form-control ${styles.blogPostFormInput}`}
                    id="post-description"
                    rows="8"
                    onChange={(e) => onDescChange(e)}
                    required
                  />
                </div> */}
                {/* <h1>React Editors</h1>
                <h2>Start editing to see some magic happen!</h2>
                <div
                  style={{
                    border: "1px solid black",
                    padding: "2px",
                    minHeight: "400px",
                  }}
                >*
                  <Editor
                    editorState={editorState}
                    onEditorStateChange={setEditorState}
                  />
                </div> */}

             
                <div className="form-group">
                  <label htmlFor="post-Images" className={styles.labelPostForm}>
                    Add Photo
                  </label>
                  <Input
                    id="file"
                    type="file"
                    name="image"
                    //   class={`form-control ${styles.blogPostFormInput}`}
                    onChange={(e) => onImageChange(e)}
                  />
                  <br />
                  <img
                    height="100px"
                    width="150px"
                    src={IMAGE_URL + image}
                  />
                </div>
                <br />
                <Input
                  type="submit"
                  name="submit"
                  className={`btn btn-danger ${styles.blogPostFormBtn}`}
                  value="Post Now"
                />
              </div>
              <br />
              <br />
            </div>
          </div>
          {/* <BlogForm handleChange={handleChange} /> */}
        </form>
      </div>
    </>
  );
}

export default SliderEdit;
